import { createContext, useContext } from 'react'

export const LocalContext = createContext<Record<string, string>>({})

let hintStatusMap: Record<string, boolean> = {}
export function $t(key: string, _local?: typeof window.local) {
  const local = _local || window.local || {}
  if (Object.prototype.toString.call(local) !== '[object Object]') return key

  let str = local[key]
  if (!str) {
    if (!hintStatusMap[key]) {
      console.warn(`key [${key}] 未找到文案`)
      hintStatusMap[key] = true
    }
  }
  return str || key
}

export function useLocal() {
  const local = useContext(LocalContext)

  const t = (key: string) => $t(key, local)

  return { $t: t }
}
